import createFetcher from './createFetcher'
import get from 'lodash/get'

const host = process.env.REACT_APP_HOST || ''
const scbSandbox = process.env.REACT_APP_QR_SANDBOX
const qrCodeOwnerID = process.env.REACT_APP_QR_OWNERID
const qrCodeKey = process.env.REACT_APP_QR_KEY
const qrType = process.env.REACT_APP_QR_TYPE
const qrPPType = process.env.REACT_APP_QR_PP_TYPE
const qrPPId = process.env.REACT_APP_PPID
const qrPrefix = process.env.REACT_APP_QR_PREFIX
const useMock = true

const defaultHeader = {
  'API-KEY': process.env.REACT_APP_APIKEY,
}

const fetchPOST = ({
  useMock= false,
  url= '',
  data= {},
  jsonMock= '',
  delay= 0,
  headers= {}
}) => {
  return (
    createFetcher({
      useMock,
      method: 'post',
      url,
      headers: {...headers},
      data,
      jsonMock,
      delay
    })
  )
}

const fetchGET = ({
  useMock= false,
  url= '',
  params= {},
  jsonMock= '',
  delay= 0,
  headers= {}
}) => {
  return (
    createFetcher({
      useMock,
      method: 'get',
      url,
      headers: {...headers, ...defaultHeader},
      params,
      jsonMock,
      delay
    })
  )
}

const fetchQRCodeAccessToken = (data) => {
  return (
    createFetcher({
      useMock: false,
      method: 'post',
      url:  `${scbSandbox}/v1/oauth/token`,
      headers: {
        'Content-Type': 'application/json',
        'resourceOwnerId': qrCodeOwnerID,
        'requestUId': get(data, 'uId', ''),
        'accept-language': 'EN'
      },
      data: {
        applicationKey: qrCodeOwnerID,
        applicationSecret: qrCodeKey,
        authCode: ''
      },
      jsonMock: ``,
      delay: 0
    })
  )
}

const fetchQRCodeImage = (accessToken, data) => {
  return (
    createFetcher({
      useMock: false,
      method: 'post',
      url:  `${scbSandbox}/v1/payment/qrcode/create`,
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${accessToken}`,
        'resourceOwnerId': qrCodeOwnerID,
        'requestUId': get(data, 'ref1', ''),
        'accept-language': 'EN'
      },
      data: {
        qrType: qrType,
        ppType: qrPPType,
        ppId: qrPPId,
        ...data,
        ref3: qrPrefix
      },
      jsonMock: ``,
      delay: 0
    })
  )
}

const fetchTripList = (data) => {
  return (
    createFetcher({
      useMock,
      method: 'post',
      url:  `${host}/api/get/triplist`,
      headers: {},
      data,
      jsonMock: `Trip.json`,
      delay: 0
    })
  )
}

const fetchPartnerList = (data) => {
  return (
    createFetcher({
      useMock,
      method: 'post',
      url:  `${host}/api/get/partnerList`,
      headers: {},
      data,
      jsonMock: `Partner.json`,
      delay: 0
    })
  )
}

const fetchRemainOrder = (data) => {
  return (
    createFetcher({
      useMock,
      method: 'post',
      url:  `${host}/api/get/remainOrderList`,
      headers: {},
      data,
      jsonMock: `RemainOrder.json`,
      delay: 0
    })
  )
}

const fetchAddNewPartner = (data) => {
  return (
    createFetcher({
      useMock,
      method: 'post',
      url:  `${host}/api/get/addNewPartner`,
      headers: {},
      data,
      jsonMock: `AddNewPartner.json`,
      delay: 0
    })
  )
}

const fetchProvince = (data) => {
  const temp = {
    // useMock,
    useMock: false,
    method: 'get',
    // url:  `${host}/api/get/triplist`,
    url:  `https://dev-spcrp.sahapat.com/api/address/getProvince`,
    headers: { 'API-KEY': '123_land-shark_456_stuffed-lizard' },
    params: data,
    jsonMock: `Province.json`,
    delay: 0
  }
  console.log('temp',temp);
  return (    
    createFetcher(temp)
  )
}

const fetchCheckTripStatus = (data) => {
  return (
    createFetcher({
      useMock,
      method: 'post',
      // url:  `${host}/sop/vansales/checktripstatus`,
      url:  `https://prodapi.sahapat.com/sop/vansales/checktripstatus`,
      headers: { 'API-KEY': '123_land-shark_456_stuffed-lizard' },
      data,
      delay: 0
    })
  )
}


const fetchGetUrlFileToFilePrint = (url) => {
  return createFetcher({
    useMock: !useMock,
    method: 'get',
    headers: {
      'content-type': 'application/pdf'
    },
    url,
    delay: 0,
    responseType: 'blob'
  })
}


export {
  fetchPOST,
  fetchGET,
  fetchTripList,
  fetchPartnerList,
  fetchRemainOrder,
  fetchAddNewPartner,
  fetchQRCodeAccessToken,
  fetchQRCodeImage,
  fetchProvince,
  fetchCheckTripStatus,
  fetchGetUrlFileToFilePrint
}
